export default function Invoice() {
  return (
    <section className="sales-layout__page">
      <h1>Rechnung schreiben</h1>
      <p>Die Rechnungserstellung ist in Vorbereitung.</p>
    </section>
  );
}
